import { motion } from "framer-motion";
import { CTAButton } from "./CTAButton";

export const FinalCTA = () => (
  <section className="py-28 md:py-40 lg:py-48 bg-[#171717] text-[#F8F7F3]" data-testid="final-cta-section">
    <div className="max-w-[1400px] mx-auto px-6 md:px-12 text-center">
      <motion.h2
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-100px" }}
        transition={{ duration: 0.7, ease: [0.16, 1, 0.3, 1] }}
        className="font-heading text-4xl md:text-5xl lg:text-6xl leading-tight tracking-tight font-medium"
      >
        Start understanding your health.
      </motion.h2>
      <motion.p
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-100px" }}
        transition={{ duration: 0.7, delay: 0.1, ease: [0.16, 1, 0.3, 1] }}
        className="mt-6 text-lg md:text-xl text-[#F8F7F3]/60 max-w-[520px] mx-auto"
      >
        Build better habits with a clearer picture of what you&rsquo;re
        actually doing.
      </motion.p>
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-100px" }}
        transition={{ duration: 0.7, delay: 0.2, ease: [0.16, 1, 0.3, 1] }}
        className="mt-10 flex justify-center"
      >
        <CTAButton
          eventName="final_cta_click"
          variant="light"
          size="lg"
          testId="final-cta-waitlist"
        />
      </motion.div>
    </div>
  </section>
);
